<template>
<svg viewBox="0 0 48 48" :fill="useCurrentColor ? 'currentColor' : '#000'" :class="[`${prefix}-icon`, `${prefix}-icon-payment-check`]" width="1em" height="1em" v-bind="$attrs"><path fill-rule="evenodd" clip-rule="evenodd" d="M42.83 23.143l5.079 5.302a.335.335 0 010 .46.305.305 0 01-.22.095H44.4C42.158 38.185 33.875 45 24 45S5.842 38.184 3.599 29h4.148C9.882 35.949 16.351 41 24 41c7.648 0 14.117-5.051 16.253-12H37.31a.318.318 0 01-.311-.325c0-.086.033-.169.091-.23l5.079-5.302a.453.453 0 01.66 0zM21.027 14.21l.094.083 2.914 2.913 2.915-2.913a1 1 0 011.414 0l1.414 1.414a1 1 0 010 1.414l-3.465 3.464H30a1 1 0 011 1v2a1 1 0 01-1 1h-4v2h4a1 1 0 011 1v2a1 1 0 01-1 1h-4v3a1 1 0 01-1 1h-2a1 1 0 01-1-1v-3h-4a1 1 0 01-1-1v-2a1 1 0 011-1h4v-2h-4a1 1 0 01-1-1v-2a1 1 0 011-1h3.756l-3.463-3.464a1 1 0 01-.083-1.32l.083-.094 1.414-1.414a1 1 0 011.32-.083zM.311 19H10.69c.082 0 .162.034.22.095a.336.336 0 01.044.4l-.044.06-5.079 5.302a.452.452 0 01-.587.063l-.073-.063-5.079-5.302a.332.332 0 01.149-.546L.31 19h10.38H.31zM24 3c9.875 0 18.158 6.816 20.401 16h-4.148C38.118 12.052 31.649 7 24 7 16.352 7 9.883 12.051 7.747 19H3.6C5.842 9.815 14.125 3 24 3z"/></svg>
</template>
<script>

export default {
  name: 'IconPaymentCheck',
  props: {
    prefix: {
        type: String,
        default: 'arco',
    },
    useCurrentColor: {
        type: Boolean,
        default: true,
    },
  },
};
</script>
